export const EXPERT_IMAGE_MIN_NUMBER_TO_SHOW_CAROUSEL = 3

export const EXPERT_BOOK_CONSULTATION_ID = 'book-consultation'

export const EXPERT_SHOWROOM_PRODUCTS_LISTING_ID = 'products-listing'
